import React from "react";
import "./App.css";
import main from "./images/logo.png";

function App() {
  return (
    <div>
      <div
        className="fixed font-light top-10 w-full z-50 mix-blend-difference"
        id="navbar"
      >
        <div className="px-10 mobilelg:px-5 flex flex-row items-center mobilelg:items-start">
          <div>
            <a href="#home">
              <img src={main} alt="logo" className="w-14 h-full" />
            </a>
          </div>
          <div className="ml-auto flex flex-row w-2/5 justify-between tablet:w-[60%]  mobilelg:flex-col mobilelg:w-fit">
            <a
              href="#about"
              className="opacity-100 border border-white rounded-full px-3 hover:bg-[#358887] transition-all duration-300 mobilelg:border-none mobilelg:pl-0 mobilelg:hover:bg-transparent"
            >
              ABOUT US
            </a>
            <a
              href="#services"
              className="opacity-100 transition-all duration-300 hover:opacity-75 "
            >
              SERVICES
            </a>
            <a
              href="#events"
              className="opacity-100 transition-all duration-300 hover:opacity-75 "
            >
              EVENTS
            </a>
            <a
              href="#footer"
              className="opacity-100 transition-all duration-300 hover:opacity-75"
            >
              CONTACT
            </a>
          </div>
        </div>
      </div>
      <div className="app">
        <div className="home" id="home">
          <div className="h-screen absolute flex justify-center items-center w-full pt-10">
            <img
              src="https://i.imgur.com/bb54fzG.png"
              alt="circle-bg"
              className="h-[80vh] blur-xl aspect-square object-cover mobilelg:h-[60vh]"
            />
          </div>
          <div className="w-full flex justify-center h-full items-center extra-ordinary pt-10 text-white">
            <div className="whitespace-pre flex flex-col w-fit mobilelg:scale-50 mobilemd:scale-[0.4] mobilesm:scale-[0.3]">
              <div className="text-4xl">WELCOME TO THE</div>
              <div className="text-9xl">
                “EXTRA <br /> ORDINARY”
              </div>
            </div>
          </div>
        </div>
        <div
          className="flex flex-row justify-center h-screen px-10 mobilelg:px-5 pt-32 tablet:h-full  mobilelg:pt-10"
          id="about"
        >
          <div className="w-1/2 text-[1.75vw] leading-[1.05]">
            Welcome to <br />
            Festival International Event Association
          </div>
          <div className="w-1/2 text-[3.2rem] leading-[1.05] text-[#358887] pl-3 tablet:text-[2rem] mobilelg:text-[1.2rem]">
            <span>
              We are a dynamic
              <br />
              and innovative <br />
              start-up
              <br />
              that provides <br /> comprehensive
              <br />
              event management <br />
              and ticket booking services
            </span>
          </div>
        </div>
        <div
          className="h-full px-10 mobilelg:px-5 mt-10 flex justify-center"
          id="services"
        >
          <div className="grid grid-cols-2 gap-6 font-bold w-full">
            <a
              href="/"
              className="relative h-[120vh] tablet:h-[80vh] mobilelg:h-[40vh] overflow-hidden bg-white rounded-xl services-card"
            >
              <img
                src="https://i.imgur.com/czIktbH.jpg"
                alt="event planning"
                className="absolute inset-0 object-cover object-center w-full h-full transition-all duration-500 transform"
              />
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-[#f08655] h-[20vh] transition-all duration-500 services-text">
                <div className="translate-y-10">
                  <h1 className="text-4xl mobilelg:text-2xl mobilemd:text-xl mobilesm:text-lg text-center">
                    EVENT MANAGEMENT
                  </h1>
                </div>
              </div>
            </a>
            <a
              href="/"
              className="relative h-[120vh] tablet:h-[80vh] mobilelg:h-[40vh] overflow-hidden bg-white rounded-xl services-card"
            >
              <img
                src="https://wallpaperaccess.com/full/2709078.jpg"
                alt="event planning"
                className="absolute inset-0 object-cover object-center w-full h-full transition-all duration-500 transform"
              />
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-[#9eafdf] h-[20vh] transition-all duration-500 services-text">
                <div className="translate-y-10">
                  <h1 className="text-4xl mobilelg:text-2xl mobilemd:text-xl mobilesm:text-lg text-center">
                    TICKET BOOKING
                  </h1>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="flex flex-row justify-center h-screen tablet:h-full px-10 mobilelg:px-5 pt-32 mobilelg:pt-10">
          <div className="w-1/2 text-[1.75vw] leading-[1.05]">
            Enjoy every celebration
          </div>
          <div className="w-1/2 text-[3.2rem] leading-[1.05] text-[#358887] pl-3 tablet:text-[2rem] mobilelg:text-[1.2rem]">
            <span className="">
              We make your
              <br />
              special day
              <br />
              an outstanding one
              <br />
              where you enjoy
              <br /> every celebration
              <br />
              with your <br />
              beloved ones
            </span>
          </div>
        </div>
        <div className="h-full relative">
          <div className="sticky top-0 flex justify-center items-center h-screen z-0">
            <img
              src="https://i.imgur.com/YGTtPnw.png"
              alt="circle-bg"
              className="h-[80vh] blur-xl aspect-square object-cover mobilelg:h-[60vh]"
            />
          </div>
          <div
            className="flex justify-center items-center flex-col z-20 relative h-full"
            id="events"
          >
            <div className="h-[100vh] w-full sticky top-0 z-10 flex justify-center items-center">
              <h1 className="text-center parat ">UPCOMING EVENTS</h1>
            </div>
            <div className="h-full w-full flex flex-row justify-between px-10 mobilelg:px-5 z-20 relative">
              <a href="/">
                <img
                  src="https://static.tixr.com/static/images/external/img/11miami/3680/20/flyer/drake-official-concert-after-party-day-1.jpg"
                  alt="drake concert"
                  className="aspect-square object-cover w-[20rem]"
                />
              </a>
              <a href="/" className="mt-[80rem]">
                <img
                  src="https://www.timeoutdubai.com/cloud/timeoutdubai/2023/01/09/wireless-festival-abu-dhabi-1024x768.png"
                  alt="wirless concert"
                  className="aspect-square object-cover w-[20rem]"
                />
              </a>
              <a href="/" className="mt-[40rem]">
                <img
                  src="https://media2.houstonpress.com/hou/imager/u/magnum/11561456/unnamed.jpeg?cb=1639706025"
                  alt="travis concert"
                  className="aspect-square object-cover w-[20rem] "
                />
              </a>
              <a href="/" className="mt-[120rem] mb-[25vh]">
                <img
                  src="https://i.imgur.com/IAKoCbU.jpg"
                  alt="marwan concert"
                  className="aspect-square object-cover w-[20rem]"
                />
              </a>
            </div>
            <div className="flex justify-center items-center h-96 z-50">
              <a
                href="/"
                className="border border-white rounded-full px-10 mobilelg:px-5 text-white hover:bg-[#358887] transition-all duration-300"
              >
                VIEW ALL
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-center h-screen tablet:h-full px-10 mobilelg:px-5 pt-32 mobilelg:py-10 ">
          <div className="w-1/2 text-[1.75vw] leading-[1.05]">
            Join your favorite vibe or <br />
            create your own
          </div>
          <div className="w-1/2 text-[3.2rem] leading-[1.05] text-[#358887] pl-3 tablet:text-[2rem] mobilelg:text-[1.2rem]">
            <span className="">
              Wether you
              <br />
              want to go
              <br />
              to an event or
              <br />
              want to create
              <br /> your own we
              <br />
              always got
              <br />
              you covered
            </span>
          </div>
        </div>
        <div
          className=" text-white-diff text-left flex flex-col font-bold overflow-x-hidden"
          id="footer"
        >
          <div id="infinite z-10">
            <div id="infinite-fx" className="ticker-wrap">
              <span>FESTIVAL INTERNATIONAL EVENT ASSOCIATION</span>
              <span>FESTIVAL INTERNATIONAL EVENT ASSOCIATION</span>
            </div>
          </div>
          <div className="z-10 tablet:text-[1.5rem] tablet:gap-20 contact">
            <ul className="text-[#358887]">
              <li>
                <a href="/">Linkedin</a>
              </li>
              <li>
                <a href="/">Instagram</a>
              </li>
              <li>
                <a href="/">Twitter</a>
              </li>
              <li>
                <span className="invisible">🗿</span>
              </li>
              <li className=" copyright">
                <span className="text-xs">@2023 FEST</span>
              </li>
            </ul>
            <ul>
              <li>
                <a href="#about">ABOUT US</a>
              </li>
              <li>
                <a href="#services">SERVICES</a>
              </li>
              <li>
                <a href="#events">EVENTS</a>
              </li>
              <li>
                <a href="#footer">CONTACT</a>
              </li>
              <li className="copyright">
                <a href="/">
                  <span className="text-xs">Cookies Policy</span>
                </a>
              </li>
            </ul>
            <ul>
              <li className="text-xs">Let's collaborate</li>
              <li className="text-xs hover:opacity-50">
                <a href="mailto:info@fest.com">info@fest.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
